<div class="d-flex">
    <div class="language" *ngFor="let language of languages">
        <a [ngClass]="{'active': language.active}" (click)="changeLanguage(language)">{{language.name}}</a>
    </div>
</div>